import { User, CreateUser } from '../models';


export class GetToken {
  static readonly type = '[UserAuth] GetToken';
  constructor(public payload: { forceRefresh?: boolean }) {
    this.payload.forceRefresh ?? false;
  }
}

export class SignUp {
  static readonly type = '[UserAuth] SignUp';
  constructor (public user: CreateUser) { }
}

export class UpdateUser {
  static readonly type = '[UserAuth] UpdateUser';
  constructor (public user: User) { }
}

export class LoginWithEmailAndPassword {
  static readonly type = '[UserAuth] LoginWithEmailAndPassword';
  constructor (public email: string, public password: string) { }
}

export class LoginWithFacebook {
  static readonly type = '[UserAuth] LoginWithFacebook';
  constructor() {}
}

export class LoginWithGoogle {
  static readonly type = '[UserAuth] LoginWithGoogle';
  constructor() {}
}

export class LoginWithAccessToken {
  static readonly type = '[UserAuth] LoginWithAccessToken';
  constructor() {}
}

export class LoginWithFirebaseState {
  static readonly type = '[UserAuth] loginWithFirebaseState';
  constructor() {}
}

export class SignOutRevokeUserToken {
  static readonly type = '[UserAuth] SignOutRevokeUserToken';
  constructor() {}
}

export class Logout {
  static readonly type = '[UserAuth] Logout';
  constructor(public message?: string) {}
}

export class SetLoggedInUser {
  static readonly type = '[UserAuth] SetLoggedInUser';
  constructor (public user: User) { }
}

export class SetToken {
  static readonly type = '[UserAuth] SetToken';
  constructor(public token: string) {}
}

export class CreateCustomToken {
  static readonly type = '[UserAuth] CreateCustomToken';
  constructor() {}
}

export class LoginWithCustomToken {
  static readonly type = '[UserAuth] LoginWithCustomToken ';
  constructor(public token: string) {}
}

export class LoginWithCustomTokenRedirect {
  static readonly type = '[UserAuth] LoginWithCustomTokenRedirect ';
  constructor(public customLoginToken?: any, public autoLoginSubdomain?: string) { }
}

export class ConfirmEmailVerification {
  static readonly type = '[UserAuth] ConfirmEmailVerification ';
  constructor(public verificationCode: string) { }
}

export class SendEmailVerification {
  static readonly type = '[UserAuth] SendEmailVerification ';
  constructor() { }
}

export class ResetAuthToDefault {
  static readonly type = '[UserAuth] ResetAuthToDefault ';
  constructor() { }
}
